import Addicon from "@mui/icons-material/Add";
import { useHistory } from "react-router-dom";
import { Button } from "$components";

type Props = {
  to?: string;
  children?: string;
  style?: Record<string, string | number>;
  disabled?: boolean;
};

export const ButtonLink = ({ to, children, style, disabled }: Props) => {
  const history = useHistory();
  return (
    <Button
      variant="outlined"
      onClick={() => history.push(to)}
      style={{ marginRight: 8, ...style }}
      startIcon={<Addicon />}
      disabled={disabled}
    >
      {children}
    </Button>
  );
};
